import useRequest from '@/websdk/utils/request';

export default function () {
  const { data, exec, isLoading, isRequestSuccessed } = useRequest({
    url: '/api/moulds',
    name: 'GET_MOULDS',
  });

  return [data || [], exec, isLoading, isRequestSuccessed];
}
